import SVG_en from 'assets/svgs/en.svg'
import SVG_ja from 'assets/svgs/ja.svg'
import SVG_ko from 'assets/svgs/ko.svg'
import SVG_zh from 'assets/svgs/zh.svg'
import SVG_zh_hk from 'assets/svgs/zh-hk.svg'

export const SupportedLanguages = [
  { icon: SVG_en, key: 'en' },
  { icon: SVG_ja, key: 'ja' },
  { icon: SVG_ko, key: 'ko' },
  { icon: SVG_zh, key: 'zh' },
  { icon: SVG_zh_hk, key: 'zh-hk' },
]

export const storageKeyLng = 'i18n'
